import { createReducer, on } from '@ngrx/store';
import { AccountOrganization } from '@smmof/entity';
import { AccountOrganizationActions } from '../actions/account-organization.actions';

export interface AccountOrganizationState {
  organizations: AccountOrganization[];
  loading: boolean;
  error: any;
}

export const initialState: AccountOrganizationState = {
  organizations: [],
  loading: false,
  error: null,
};

export const accountOrganizationReducer = createReducer(
  initialState,
  // Загрузка организаций
  on(AccountOrganizationActions.loadOrganizations, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(AccountOrganizationActions.loadOrganizationsSuccess, (state, { organizations }) => ({
    ...state,
    organizations,
    loading: false,
    error: null,
  })),
  on(AccountOrganizationActions.loadOrganizationsFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),
  // Создание организации
  on(AccountOrganizationActions.createOrganization, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(AccountOrganizationActions.createOrganizationSuccess, (state, { organization }) => ({
    ...state,
    organizations: [...state.organizations, organization],
    loading: false,
    error: null,
  })),
  on(AccountOrganizationActions.createOrganizationFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  // Сброс ошибки
  on(AccountOrganizationActions.clearOrganizationError, (state) => ({
    ...state,
    error: null,
  }))
);